import * as ng from 'angular';
import * as xml2js from 'xml2js';
import {ArchiSmallServices} from '../../../../../services/archismall.service';
import {CassaService} from '../../../../../services/data/cassa.service';
import {appContext} from '../../../../../app.context';
import {VATService} from '../../../../../services/data/vat.service';
import {ICessionarioCommittente} from '../../../../../commons/interfaces/invoices/fattura';

class PrComponiFatturaAvanzataController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    'ArchiSmallServices',
    'CassaService',
    'VATService',
    '$sce',
    '$timeout',
    '$uibModal',
    '$parse'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private ArchiSmallServices: ArchiSmallServices,
    private cassaService: CassaService,
    private vatService: VATService,
    private $sce: ng.ISCEService,
    private $timeout: ng.ITimeoutService,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $parse: ng.IParseService
  ) {
    /* tslint:disable:no-string-literal */
    $rootScope.loading = true;
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };
    // <editor-fold desc='JSON Definition'>

    let DatiCassaPrevidenzialeItem = {
      'TipoCassa': '',
      'AlCassa': '0.00',
      'ImportoContributoCassa': '0.00',
      'ImponibileCassa': '0.00',
      'AliquotaIVA': '0.00',
      'Ritenuta': '',
      'Natura': '',
      'RiferimentoAmministrazione': ''
    };
    let ScontoMaggiorazioneItem = {
      'Tipo': '',
      'Percentuale': '0.00',
      'Importo': '0.00'
    };
    let CausaleItem = {
      'Causale': '' // ??
    };
    let RiferimentoNumeroLineaItem = {
      'RiferimentoNumeroLinea': '' // ??
    };
    let DatiOrdineAcquistoItem = {
      'RiferimentoNumeroLinea': [],
      'IdDocumento': '',
      'Data': '',
      'NumItem': '',
      'CodiceCommessaConvenzione': '',
      'CodiceCUP': '',
      'CodiceCIG': ''
    };
    let DatiContrattoItem = {
      'RiferimentoNumeroLinea': [],
      'IdDocumento': '',
      'Data': '',
      'NumItem': '',
      'CodiceCommessaConvenzione': '',
      'CodiceCUP': '',
      'CodiceCIG': ''
    };
    let DatiConvenzioneItem = {
      'RiferimentoNumeroLinea': [],
      'IdDocumento': '',
      'Data': '',
      'NumItem': '',
      'CodiceCommessaConvenzione': '',
      'CodiceCUP': '',
      'CodiceCIG': ''
    };
    let DatiRicezioneItem = {
      'RiferimentoNumeroLinea': [],
      'IdDocumento': '',
      'Data': '',
      'NumItem': '',
      'CodiceCommessaConvenzione': '',
      'CodiceCUP': '',
      'CodiceCIG': ''
    };
    let DatiFattureCollegateItem = {
      'RiferimentoNumeroLinea': [],
      'IdDocumento': '',
      'Data': '',
      'NumItem': '',
      'CodiceCommessaConvenzione': '',
      'CodiceCUP': '',
      'CodiceCIG': ''
    };
    let DatiSALItem = {
      'RiferimentoFase': ''
    };
    let DatiDDTItem = {
      'NumeroDDT': '',
      'DataDDT': '',
      'RiferimentoNumeroLinea': []
    };
    //                let CodiceArticoloItem = {
    //                    'CodiceTipo': '',
    //                    'CodiceValore': ''
    //                };
    //                let AltriDatiGestionaliItem = {
    //                    'TipoDato': '',
    //                    'RiferimentoTesto': '',
    //                    'RiferimentoNumero': '',
    //                    'RiferimentoData': ''
    //                };

    let DettaglioLineeItem = {
      'NumeroLinea': '',
      'TipoCessionePrestazione': '',
      'CodiceArticolo': [],
      'Descrizione': '',
      'Quantita': '0.00',
      'UnitaMisura': '',
      'DataInizioPeriodo': '',
      'DataFinePeriodo': '',
      'PrezzoUnitario': '0.00',
      'ScontoMaggiorazione': [],
      'PrezzoTotale': '0.00',
      'AliquotaIVA': '0.00',
      'Ritenuta': '',
      'Natura': '',
      'RiferimentoAmministrazione': '',
      'AltriDatiGestionali': []
    };
    let DatiRiepilogoItem = {
      'AliquotaIVA': '0.00',
      'Natura': '',
      'SpeseAccessorie': '0.00',
      'Arrotondamento': '0.00',
      'ImponibileImporto': '0.00',
      'Imposta': '0.00',
      'EsigibilitaIVA': '',
      'RiferimentoNormativo': ''
    };
    let DettaglioPagamentoItem = {
      'Beneficiario': '',
      'ModalitaPagamento': '',
      'DataRiferimentoTerminiPagamento': '',
      'GiorniTerminiPagamento': '',
      'DataScadenzaPagamento': '',
      'ImportoPagamento': '0.00',
      'CodUfficioPostale': '',
      'CognomeQuietanzante': '',
      'NomeQuietanzante': '',
      'CFQuietanzante': '',
      'TitoloQuietanzante': '',
      'IstitutoFinanziario': '',
      'IBAN': '',
      'ABI': '',
      'CAB': '',
      'BIC': '',
      'ScontoPagamentoAnticipato': '0.00',
      'DataLimitePagamentoAnticipato': '',
      'PenalitaPagamentiRitardati': '0.00',
      'DataDecorrenzaPenale': '',
      'CodicePagamento': ''
    };
    let DatiPagamentoItem = {
      'CondizioniPagamento': '',
      'DettaglioPagamento': []
    };
    let AllegatiItem = {
      'NomeAttachment': '',
      'AlgoritmoCompressione': '',
      'FormatoAttachment': '',
      'DescrizioneAttachment': '',
      'Attachment': ''
    };
    let DatiRitenutaItem = {
      'TipoRitenuta': '',
      'ImportoRitenuta': '0.00',
      'AliquotaRitenuta': '0.00',
      'CausalePagamento': ''
    };
    let DatiBolloItem = {
      'BolloVirtuale': '',
      'ImportoBollo': '0.00'
    };
    let DatiAnagraficiVettoreItem = {
      'IdFiscaleIVA': {
        'IdPaese': '',
        'IdCodice': ''
      },
      'CodiceFiscale': '',
      'Anagrafica': {
        'Denominazione': '',
        'Titolo': '',
        'CodEORI': ''
      },
      'NumeroLicenzaGuida': ''
    };
    let IndirizzoResaItem = {
      'Indirizzo': '',
      'NumeroCivico': '',
      'CAP': '',
      'Comune': '',
      'Provincia': '',
      'Nazione': ''
    };
    let DatiTrasportoItem = {
      'DatiAnagraficiVettore': {},
      'MezzoTrasporto': '',
      'CausaleTrasporto': '',
      'NumeroColli': '',
      'Descrizione': '',
      'UnitaMisuraPeso': '',
      'PesoLordo': '0.00',
      'PesoNetto': '0.00',
      'DataOraRitiro': '',
      'DataInizioTrasporto': '',
      'TipoResa': '',
      'IndirizzoResa': {},
      'DataOraConsegna': ''
    };
    let FatturaPrincipaleItem = {
      'NumeroFatturaPrincipale': '',
      'DataFatturaPrincipale': ''
    };
    let DatiVeicoliItem = {
      'Data': '',
      'TotalePercorso': ''
    };
    let FatturaElettronicaBodyItem = {
      'DatiGenerali': {
        'DatiGeneraliDocumento': {
          'TipoDocumento': '',
          'Divisa': '',
          'Data': '',
          'Numero': '',
          'DatiRitenuta': [],
          'DatiBollo': {},
          'DatiCassaPrevidenziale': [],
          'ScontoMaggiorazione': [],
          'ImportoTotaleDocumento': undefined,
          'Arrotondamento': '',
          'Causale': [],
          'Art73': ''
        },
        'DatiOrdineAcquisto': [],
        'DatiContratto': [],
        'DatiConvenzione': [],
        'DatiRicezione': [],
        'DatiFattureCollegate': [],
        'DatiSAL': [],
        'DatiDDT': [],
        'DatiTrasporto': {},
        'FatturaPrincipale': {}
      },
      'DatiBeniServizi': {
        'DettaglioLinee': [],
        'DatiRiepilogo': []
      },
      'DatiVeicoli': {},
      'DatiPagamento': [],
      'Allegati': []
    };
    let ContattiTrasmittenteItem = {
      'Telefono': '',
      'Email': ''
    };
    let StabileOrganizzazioneItem = {
      'Indirizzo': '',
      'NumeroCivico': '',
      'CAP': '',
      'Comune': '',
      'Provincia': '',
      'Nazione': ''
    };
    let IscrizioneREAItem = {
      'Ufficio': '',
      'NumeroREA': '',
      'CapitaleSociale': '',
      'SocioUnico': '',
      'StatoLiquidazione': ''
    };
    let ContattiItem = {
      'Telefono': '',
      'Fax': '',
      'Email': ''
    };
    let RappresentanteFiscaleItem = {
      'DatiAnagrafici': {
        'IdFiscaleIVA': {
          'IdPaese': '',
          'IdCodice': ''
        },
        'CodiceFiscale': '',
        'Anagrafica': {
          'Denominazione': '',
          'Titolo': '',
          'CodEORI': '',
          'Nome': '',
          'Cognome': ''
        }
      }
    };
    //                let TerzoIntermediarioOSoggettoEmittenteItem = {
    //                    'DatiAnagrafici': {
    //                        'IdFiscaleIVA': {
    //                            'IdPaese': '',
    //                            'IdCodice': ''
    //                        },
    //                        'CodiceFiscale': '',
    //                        'Anagrafica': {
    //                            'Denominazione': '',
    //                            'Titolo': '',
    //                            'CodEORI': ''
    //                        }
    //                    }
    //                };
    let IdFiscaleIVAItem = {
      'IdPaese': '',
      'IdCodice': ''
    };
    let FatturaPA = {
      'FatturaPA': {
        'FatturaElettronicaHeader': {
          'DatiTrasmissione': {
            'IdTrasmittente': {
              'IdPaese': 'IT',
              'IdCodice': '02576660365'
            },
            'ProgressivoInvio': '',
            'FormatoTrasmissione': 'FPR12',
            'CodiceDestinatario': '',
            'ContattiTrasmittente': {
              'Telefono': '059330959',
              'Email': 'helpdesk@archismall.com'
            }
          },
          'CedentePrestatore': {
            'DatiAnagrafici': {
              'IdFiscaleIVA': {
                'IdPaese': '',
                'IdCodice': ''
              },
              'CodiceFiscale': '',
              'Anagrafica': {
                'Denominazione': '',
                'Titolo': '',
                'CodEORI': ''
              },
              'AlboProfessionale': '',
              'ProvinciaAlbo': '',
              'NumeroIscrizioneAlbo': '',
              'DataIscrizioneAlbo': '',
              'RegimeFiscale': ''
            },
            'Sede': {
              'Indirizzo': '',
              'NumeroCivico': '',
              'CAP': '',
              'Comune': '',
              'Provincia': '',
              'Nazione': ''
            },
            'StabileOrganizzazione': {},
            'IscrizioneREA': {},
            'Contatti': {},
            'RiferimentoAmministrazione': ''
          },
          'RappresentanteFiscale': {},
          'CessionarioCommittente': {
            'DatiAnagrafici': {
              'IdFiscaleIVA': {},
              'CodiceFiscale': '',
              'Anagrafica': {
                'Denominazione': '',
                'Titolo': '',
                'CodEORI': ''
              }
            },
            'Sede': {
              'Indirizzo': '',
              'NumeroCivico': '',
              'CAP': '',
              'Comune': '',
              'Provincia': '',
              'Nazione': ''
            }
          },
          'SoggettoEmittente': ''
        },
        'FatturaElettronicaBody': []
      }
    };

    $scope.destinatarioItem = undefined;

    $scope.DettaglioPagamentoIsIncluded = [];
    DatiPagamentoItem.DettaglioPagamento.push(jQuery.extend(true, {}, DettaglioPagamentoItem));

    $scope.TitoloType = new RegExp('^[\u0000-\u007F]{2,10}$');
    $scope.String10Type = new RegExp('^[\u0000-\u007F]{1,10}$');
    $scope.String15Type = new RegExp('^[\u0000-\u007F]{1,15}$');
    $scope.String20Type = new RegExp('^[\u0000-\u007F]{1,20}$');
    $scope.String35Type = new RegExp('^[\u0000-\u007F]{1,35}$');
    $scope.String60Type = new RegExp('^[\u0000-\u007F]{1,60}$');
    $scope.String80Type = new RegExp('^[\u0000-\u007F]{1,80}$');
    $scope.String100Type = new RegExp('^[\u0000-\u007F]{1,100}$');
    $scope.String60LatinType = new RegExp('^[\u0000-\u00FF]{1,60}$');
    $scope.String80LatinType = new RegExp('^[\u0000-\u00FF]{1,80}$');
    $scope.String100LatinType = new RegExp('^[\u0000-\u00FF]{1,100}$');
    $scope.String200LatinType = new RegExp('^[\u0000-\u00FF]{1,200}$');
    $scope.String1000LatinType = new RegExp('^[\u0000-\u00FF]{1,1000}$');
    $scope.TelFaxType = new RegExp('^[\u0000-\u007F]{5,12}$');
    $scope.EmailType = new RegExp('^.+@.+[.]+.+$');
    $scope.ProvinciaType = new RegExp('^[A-Z]{2}$');
    $scope.NazioneType = new RegExp('^[A-Z]{2}$');
    $scope.DivisaType = new RegExp('^[A-Z]{3}$');
    $scope.TipoResaType = new RegExp('^[A-Z]{3}$');
    $scope.NumeroCivicoType = new RegExp('^[\u0000-\u007F]{1,8}$');
    $scope.CodiceType = new RegExp('^.{1,28}$');
    $scope.CodiceDestinatarioType = new RegExp('^[A-Z0-9]{7}$');
    $scope.IdDestinatarioCodUfficioType = new RegExp('^.{1,16}$');
    $scope.RiferimentoNumeroLineaType = new RegExp('^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])$'); // 1-9999
    $scope.IBANType = new RegExp('^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{23,30}$');
    $scope.BICType = new RegExp('^[A-Z]{6}[A-Z2-9][A-NP-Z0-9]([A-Z0-9]{3}){0,1}$');
    $scope.CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    $scope.CodiceFiscalePFType = new RegExp('^[A-Z0-9]{16}$');
    $scope.CodEORIType = new RegExp('^.{13,17}$');
    $scope.RiferimentoFaseType = new RegExp('^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$'); // 1-999
    $scope.NumeroColliType = new RegExp('^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])$'); // 1-9999
    $scope.NumeroLineaType = new RegExp('^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])$'); // 1-9999
    $scope.CAPType = new RegExp('^[0-9]{5}$');
    $scope.ABIType = new RegExp('^[0-9]{5}$');
    $scope.CABType = new RegExp('^[0-9]{5}$');
    $scope.GiorniTerminePagamentoType = new RegExp('^([0-9]{1,3})$'); // 0-999
    $scope.data = new RegExp('^[0-9]{2}/[0-9]{2}/[0-9]{4}$');

    // <editor-fold desc='Select Values'>
    $scope.StatoLiquidazioneType = {
      'LS': 'in liquidazione',
      'LN': 'non in liquidazione'
    };
    $scope.RegimeFiscaleType = {
      'RF01': 'Regime ordinario',
      'RF02': 'Regime dei contribuenti minimi (art. 1,c.96-117, L. 244/2007)',
      'RF04': 'Agricoltura e attività connesse e pesca (artt. 34 e 34-bis, D.P.R. 633/1972)',
      'RF05': 'Vendita sali e tabacchi (art. 74, c.1, D.P.R. 633/1972)',
      'RF06': 'Commercio dei fiammiferi (art. 74, c.1, D.P.R. 633/1972)',
      'RF07': 'Editoria (art. 74, c.1, D.P.R. 633/1972)',
      'RF08': 'Gestione di servizi di telefonia pubblica (art. 74, c.1, D.P.R. 633/1972)',
      'RF09': 'Rivendita di documenti di trasporto pubblico e di sosta (art. 74, c.1, D.P.R. 633/1972)',
      'RF10': 'Intrattenimenti, giochi e altre attività di cui alla tariffa allegata al D.P.R. 640/72 (art. 74, c.6, D.P.R. 633/1972)',
      'RF11': 'Agenzie di viaggi e turismo (art. 74-ter, D.P.R. 633/1972)',
      'RF12': 'Agriturismo (art. 5, c.2, L. 413/1991)',
      'RF13': 'Vendite a domicilio (art. 25-bis, c.6, D.P.R. 600/1973)',
      'RF14': 'Rivendita di beni usati, di oggetti d’arte, d’antiquariato o da collezione (art. 36, D.L. 41/1995)',
      'RF15': 'Agenzie di vendite all’asta di oggetti d’arte, antiquariato o da collezione (art. 40-bis, D.L. 41/1995)',
      'RF16': 'IVA per cassa P.A. (art. 6, c.5, D.P.R. 633/1972)',
      'RF17': 'IVA per cassa (art. 32-bis, D.L. 83/2012)',
      'RF18': 'Altro',
      'RF19': 'Regime forfettario',
      'RF20': 'Regime transfrontaliero di Franchigia IVA (Direttiva UE 2020/285)'
    };
    $scope.SocioUnicoType = {
      'SU': 'Socio unico',
      'SM': 'Più soci'
    };
    $scope.FormatoTrasmissioneType = {
      'FPR12': 'Formato di Trasmissione fattura verso privati-ver. 1.2'
    };
    $scope.SoggettoEmittente = {
      'CC': 'Cessionario / Committente',
      'TZ': 'Terzo'
    };
    $scope.TipoDocumentoType = {
      'TD01': 'TD01 - Fattura',
      'TD02': 'TD02 - Acconto / anticipo su fattura',
      'TD03': 'TD03 - Acconto / anticipo su parcella',
      'TD04': 'TD04 - Nota di credito',
      'TD05': 'TD05 - Nota di debito',
      'TD06': 'TD06 - Parcella',
      'TD16': 'TD16 - Integrazione fattura reverse charge interno',
      'TD17': 'TD17 - Integrazione/autofattura per acquisto servizi dall\'estero',
      'TD18': 'TD18 - Integrazione per acquisto di beni intracomunitari',
      'TD19': 'TD19 - Integrazione/autofattura per acquisto di beni ex art.17 c.2 DPR 633/72',
      'TD20': 'TD20 - Autofattura per regolarizzazione e integrazione delle fatture (ex art. 6 c.9-bis d.lgs. 471/97 o art.46 c.5 D.L. 331/93)',
      'TD21': 'TD21 - Autofattura per splafonamento',
      'TD22': 'TD22 - Estrazione benida Deposito IVA',
      'TD23': 'TD23 - Estrazione beni da Deposito IVA con versamento dell\'IVA',
      'TD24': 'TD24 - Fattura differita di cui all\'art.21, comma 4, terzo periodo lett. a) DPR 633/72',
      'TD25': 'TD25 - Fattura differita di cui all\'art.21, comma 4, terzo periodo lett. b) DPR 633/72',
      'TD26': 'TD26 - Cessione di beni ammortizzabili e per passaggi interni (ex art.36 DPR 633/72)',
      'TD27': 'TD27 - Fattura per autoconsumo o per cessioni gratuite senza rivalsa',
      'TD28': 'TD28 - Acquisti da San Marino con IVA (fattura cartacea)',
      'TD29': 'TD29 - Comunicazione per omessa o irregolare fatturazione da parte del cedente/prestatore italiano (art. 6, comma 8, D.Lgs. 471/97)'
    };
    $scope.TipoRitenutaType = {
      'RT01': 'RT01 - Ritenuta di acconto persone fisiche',
      'RT02': 'RT02 - Ritenuta di acconto persone giuridiche',
      'RT03': 'RT03 - Contributo INPS',
      'RT04': 'RT04 - Contributo ENASARCO',
      'RT05': 'RT05 - Contributo ENPAM',
      'RT06': 'RT06 - Altro contributo previdenziale'
    };
    $scope.RitenutaType = {
      '': '',
      'SI': 'SI = Cessione / Prestazione soggetta a ritenuta'
    };
    $scope.BolloVirtualeType = {
      'SI': 'SI'
    };
    $scope.Art73Type = {
      '': '',
      'SI': 'SI = Documento emesso secondo modalità e termini stabiliti con DM ai sensi dell\'art. 73 DPR 633/72'
    };
    $scope.TipoCassaType = this.cassaService.getItems();
    $scope.NaturaType = this.vatService.getItems().filter(item => item['data-natura']).map(item => ({[item['data-natura']]: item.label})).reduce((acc, curr) => {
      return {...acc, ...curr};
    });
    $scope.NaturaType = {'': '', ...$scope.NaturaType};
    $scope.CausalePagamentoType = {
      'A': 'A - Prestazioni di lavoro autonomo rientranti nell’esercizio di arte o professione abituale',
      'B': 'B - Utilizzazione economica, da parte dell’autore o dell’inventore, di opere dell’ingegno, di brevetti industriali e di processi, formule o informazioni relativi a esperienze acquisite in campo industriale, commerciale o scientifico',
      'C': 'C - Utili derivanti da contratti di associazione in partecipazione e da contratti di cointeressenza, quando l’apporto è costituito esclusivamente dalla prestazione di lavoro',
      'D': 'D - Utili spettanti ai soci promotori e ai soci fondatori delle società di capitali',
      'E': 'E - Levata di protesti cambiari da parte dei segretari comunali',
      'G': 'G - Indennità corrisposte per la cessazione di attività sportiva professionale',
      'H': 'H - Indennità corrisposte per la cessazione dei rapporti di agenzia delle persone fisiche e delle società di persone, con esclusione delle somme maturate entro il 31.12.2003, già imputate per competenza e tassate come reddito d’impresa',
      'I': 'I - Indennità corrisposte per la cessazione da funzioni notarili',
      'L': 'L - Utilizzazione economica, da parte di soggetto diverso dall’autore o dall’inventore, di opere dell’ingegno, di brevetti industriali e di processi, formule e informazioni relative a esperienze acquisite in campo industriale, commerciale o scientifico',
      'M': 'M - Prestazioni di lavoro autonomo non esercitate abitualmente, obblighi di fare, di non fare o permettere',
      'N': 'N - Indennità di trasferta, rimborso forfetario di spese, premi e compensi erogati : .. nell’esercizio diretto di attività sportive dilettantistiche',
      'O': 'O - Prestazioni di lavoro autonomo non esercitate abitualmente, obblighi di fare, di non fare o permettere, per le quali non sussiste l’obbligo di iscrizione alla gestione separata (Circ. Inps 104/2001)',
      'P': 'P - Compensi corrisposti a soggetti non residenti privi di stabile organizzazione per l’uso o la concessione in uso di attrezzature industriali, commerciali o scientifiche che si trovano nel territorio dello',
      'Q': 'Q - Provvigioni corrisposte ad agente o rappresentante di commercio monomandatario',
      'R': 'R - Provvigioni corrisposte ad agente o rappresentante di commercio plurimandatario',
      'S': 'S - Provvigioni corrisposte a commissionario',
      'T': 'T - Provvigioni corrisposte a mediatore',
      'U': 'U - Provvigioni corrisposte a procacciatore di affari',
      'V': 'V - Provvigioni corrisposte a incaricato per le vendite a domicilio e provvigioni corrisposte a incaricato per la vendita porta a porta e per la vendita ambulante di giornali quotidiani e periodici (L. 25.02.1987, n. 67)',
      'W': 'W - Corrispettivi erogati nel 2013 per prestazioni relative a contratti d’appalto cui si sono resi applicabili le disposizioni contenute nell’art. 25-ter D.P.R. 600/1973',
      'X': 'X - Canoni corrisposti nel 2004 da società o enti residenti, ovvero da stabili organizzazioni di società estere di cui all’art. 26-quater, c. 1, lett. a) e b) D.P.R. 600/1973, a società o stabili organizzazioni di società, situate in altro Stato membro dell’Unione Europea in presenza dei relativi requisiti richiesti, per i quali è stato effettuato nel 2006 il rimborso della ritenuta ai sensi dell’art. 4 D. Lgs. 143/2005',
      'Y': 'Y - Canoni corrisposti dal 1.01.2005 al 26.07.2005 da soggetti di cui al punto precedente',
      'ZO': 'ZO - Titolo diverso dai precedenti',
      'L1': 'L1 - Redditi derivanti dall’utilizzazione economica di opere dell’ingegno, di brevetti industriali e di processi, che sono percepiti da soggetti che abbiano acquistato a titolo oneroso i diritti alla loro utilizzazione.',
      'M1': 'M1 - Redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere.',
      'M2': 'M2 - Prestazioni di lavoro autonomo non esercitate abitualmente per le quali sussiste l’obbligo di iscrizione alla Gestione Separata ENPAPI.',
      'O1': 'O1 - Redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere, per le quali non sussiste l’obbligo di iscrizione alla gestione separata (Circ. INPS n. 104/2001).',
      'V1': 'V1 - Redditi derivanti da attività commerciali non esercitate abitualmente (ad esempio, provvigioni corrisposte per prestazioni occasionali ad agente o rappresentante di commercio, mediatore, procacciatore d’affari);',
    };
    $scope.TipoScontoMaggiorazioneType = {
      'SC': 'SC = Sconto',
      'MG': 'MG = Maggiorazione'
    };
    $scope.TipoCessionePrestazioneType = {
      '': '',
      'SC': 'Sconto',
      'PR': 'Premio',
      'AB': 'Abbuono',
      'AC': 'Spesa accessoria'
    };
    $scope.EsigibilitaIVAType = {
      '': '',
      'D': 'esigibilità differita',
      'I': 'esigibilità immediata',
      'S': 'scissione dei pagamenti'
    };
    $scope.CondizioniPagamentoType = {
      'TP01': 'pagamento a rate',
      'TP02': 'pagamento completo',
      'TP03': 'anticipo'
    };
    $scope.ModalitaPagamentoType = {
      'MP01': 'contanti',
      'MP02': 'assegno',
      'MP03': 'assegno circolare',
      'MP04': 'contanti presso Tesoreria',
      'MP05': 'bonifico',
      'MP06': 'vaglia cambiario',
      'MP07': 'bollettino bancario',
      'MP08': 'carta di pagamento',
      'MP09': 'RID',
      'MP10': 'RID utenze',
      'MP11': 'RID veloce',
      'MP12': 'RIBA',
      'MP13': 'MAV',
      'MP14': 'quietanza erario',
      'MP15': 'giroconto su conti di contabilità speciale',
      'MP16': 'domiciliazione bancaria',
      'MP17': 'domiciliazione postale',
      'MP18': 'bollettino di c/c postale',
      'MP19': 'SEPA Direct Debit',
      'MP20': 'SEPA Direct Debit CORE',
      'MP21': 'SEPA Direct Debit B2B'
    };
    $scope.countriesCode = {
      'IT': 'Italy',
      'AF': 'Afghanistan',
      'AX': 'Åland Islands',
      'AL': 'Albania',
      'DZ': 'Algeria',
      'AS': 'American Samoa',
      'AD': 'Andorra',
      'AO': 'Angola',
      'AI': 'Anguilla',
      'AQ': 'Antarctica',
      'AG': 'Antigua and Barbuda',
      'AR': 'Argentina',
      'AM': 'Armenia',
      'AW': 'Aruba',
      'AU': 'Australia',
      'AT': 'Austria',
      'AZ': 'Azerbaijan',
      'BS': 'Bahamas',
      'BH': 'Bahrain',
      'BD': 'Bangladesh',
      'BB': 'Barbados',
      'BY': 'Belarus',
      'BE': 'Belgium',
      'BZ': 'Belize',
      'BJ': 'Benin',
      'BM': 'Bermuda',
      'BT': 'Bhutan',
      'BO': 'Bolivia, Plurinational State of',
      'BQ': 'Bonaire, Sint Eustatius and Saba',
      'BA': 'Bosnia and Herzegovina',
      'BW': 'Botswana',
      'BV': 'Bouvet Island',
      'BR': 'Brazil',
      'IO': 'British Indian Ocean Territory',
      'BN': 'Brunei Darussalam',
      'BG': 'Bulgaria',
      'BF': 'Burkina Faso',
      'BI': 'Burundi',
      'KH': 'Cambodia',
      'CM': 'Cameroon',
      'CA': 'Canada',
      'CV': 'Cape Verde',
      'KY': 'Cayman Islands',
      'CF': 'Central African Republic',
      'TD': 'Chad',
      'CL': 'Chile',
      'CN': 'China',
      'CX': 'Christmas Island',
      'CC': 'Cocos (Keeling) Islands',
      'CO': 'Colombia',
      'KM': 'Comoros',
      'CG': 'Congo',
      'CD': 'Congo, the Democratic Republic of the',
      'CK': 'Cook Islands',
      'CR': 'Costa Rica',
      'CI': 'Côte d\'Ivoire',
      'HR': 'Croatia',
      'CU': 'Cuba',
      'CW': 'Curaçao',
      'CY': 'Cyprus',
      'CZ': 'Czech Republic',
      'DK': 'Denmark',
      'DJ': 'Djibouti',
      'DM': 'Dominica',
      'DO': 'Dominican Republic',
      'EC': 'Ecuador',
      'EG': 'Egypt',
      'SV': 'El Salvador',
      'GQ': 'Equatorial Guinea',
      'ER': 'Eritrea',
      'EE': 'Estonia',
      'ET': 'Ethiopia',
      'FK': 'Falkland Islands (Malvinas)',
      'FO': 'Faroe Islands',
      'FJ': 'Fiji',
      'FI': 'Finland',
      'FR': 'France',
      'GF': 'French Guiana',
      'PF': 'French Polynesia',
      'TF': 'French Southern Territories',
      'GA': 'Gabon',
      'GM': 'Gambia',
      'GE': 'Georgia',
      'DE': 'Germany',
      'GH': 'Ghana',
      'GI': 'Gibraltar',
      'GR': 'Greece',
      'GL': 'Greenland',
      'GD': 'Grenada',
      'GP': 'Guadeloupe',
      'GU': 'Guam',
      'GT': 'Guatemala',
      'GG': 'Guernsey',
      'GN': 'Guinea',
      'GW': 'Guinea-Bissau',
      'GY': 'Guyana',
      'HT': 'Haiti',
      'HM': 'Heard Island and McDonald Islands',
      'VA': 'Holy See (Vatican City State)',
      'HN': 'Honduras',
      'HK': 'Hong Kong',
      'HU': 'Hungary',
      'IS': 'Iceland',
      'IN': 'India',
      'ID': 'Indonesia',
      'IR': 'Iran, Islamic Republic of',
      'IQ': 'Iraq',
      'IE': 'Ireland',
      'IM': 'Isle of Man',
      'IL': 'Israel',
      'JM': 'Jamaica',
      'JP': 'Japan',
      'JE': 'Jersey',
      'JO': 'Jordan',
      'KZ': 'Kazakhstan',
      'KE': 'Kenya',
      'KI': 'Kiribati',
      'KP': 'Korea, Democratic People\'s Republic of',
      'KR': 'Korea, Republic of',
      'KW': 'Kuwait',
      'KG': 'Kyrgyzstan',
      'LA': 'Lao People\'s Democratic Republic',
      'LV': 'Latvia',
      'LB': 'Lebanon',
      'LS': 'Lesotho',
      'LR': 'Liberia',
      'LY': 'Libya',
      'LI': 'Liechtenstein',
      'LT': 'Lithuania',
      'LU': 'Luxembourg',
      'MO': 'Macao',
      'MK': 'Macedonia, the Former Yugoslav Republic of',
      'MG': 'Madagascar',
      'MW': 'Malawi',
      'MY': 'Malaysia',
      'MV': 'Maldives',
      'ML': 'Mali',
      'MT': 'Malta',
      'MH': 'Marshall Islands',
      'MQ': 'Martinique',
      'MR': 'Mauritania',
      'MU': 'Mauritius',
      'YT': 'Mayotte',
      'MX': 'Mexico',
      'FM': 'Micronesia, Federated States of',
      'MD': 'Moldova, Republic of',
      'MC': 'Monaco',
      'MN': 'Mongolia',
      'ME': 'Montenegro',
      'MS': 'Montserrat',
      'MA': 'Morocco',
      'MZ': 'Mozambique',
      'MM': 'Myanmar',
      'NA': 'Namibia',
      'NR': 'Nauru',
      'NP': 'Nepal',
      'NL': 'Netherlands',
      'NC': 'New Caledonia',
      'NZ': 'New Zealand',
      'NI': 'Nicaragua',
      'NE': 'Niger',
      'NG': 'Nigeria',
      'NU': 'Niue',
      'NF': 'Norfolk Island',
      'MP': 'Northern Mariana Islands',
      'NO': 'Norway',
      'OM': 'Oman',
      'PK': 'Pakistan',
      'PW': 'Palau',
      'PS': 'Palestine, State of',
      'PA': 'Panama',
      'PG': 'Papua New Guinea',
      'PY': 'Paraguay',
      'PE': 'Peru',
      'PH': 'Philippines',
      'PN': 'Pitcairn',
      'PL': 'Poland',
      'PT': 'Portugal',
      'PR': 'Puerto Rico',
      'QA': 'Qatar',
      'RE': 'Réunion',
      'RO': 'Romania',
      'RU': 'Russian Federation',
      'RW': 'Rwanda',
      'BL': 'Saint Barthélemy',
      'SH': 'Saint Helena, Ascension and Tristan da Cunha',
      'KN': 'Saint Kitts and Nevis',
      'LC': 'Saint Lucia',
      'MF': 'Saint Martin (French part)',
      'PM': 'Saint Pierre and Miquelon',
      'VC': 'Saint Vincent and the Grenadines',
      'WS': 'Samoa',
      'SM': 'San Marino',
      'ST': 'Sao Tome and Principe',
      'SA': 'Saudi Arabia',
      'SN': 'Senegal',
      'RS': 'Serbia',
      'SC': 'Seychelles',
      'SL': 'Sierra Leone',
      'SG': 'Singapore',
      'SX': 'Sint Maarten (Dutch part)',
      'SK': 'Slovakia',
      'SI': 'Slovenia',
      'SB': 'Solomon Islands',
      'SO': 'Somalia',
      'ZA': 'South Africa',
      'GS': 'South Georgia and the South Sandwich Islands',
      'SS': 'South Sudan',
      'ES': 'Spain',
      'LK': 'Sri Lanka',
      'SD': 'Sudan',
      'SR': 'Suriname',
      'SJ': 'Svalbard and Jan Mayen',
      'SZ': 'Swaziland',
      'SE': 'Sweden',
      'CH': 'Switzerland',
      'SY': 'Syrian Arab Republic',
      'TW': 'Taiwan, Province of China',
      'TJ': 'Tajikistan',
      'TZ': 'Tanzania, United Republic of',
      'TH': 'Thailand',
      'TL': 'Timor-Leste',
      'TG': 'Togo',
      'TK': 'Tokelau',
      'TO': 'Tonga',
      'TT': 'Trinidad and Tobago',
      'TN': 'Tunisia',
      'TR': 'Turkey',
      'TM': 'Turkmenistan',
      'TC': 'Turks and Caicos Islands',
      'TV': 'Tuvalu',
      'UG': 'Uganda',
      'UA': 'Ukraine',
      'AE': 'United Arab Emirates',
      'GB': 'United Kingdom',
      'US': 'United States',
      'UM': 'United States Minor Outlying Islands',
      'UY': 'Uruguay',
      'UZ': 'Uzbekistan',
      'VU': 'Vanuatu',
      'VE': 'Venezuela, Bolivarian Republic of',
      'VN': 'Viet Nam',
      'VG': 'Virgin Islands, British',
      'VI': 'Virgin Islands, U.S.',
      'WF': 'Wallis and Futuna',
      'EH': 'Western Sahara',
      'YE': 'Yemen',
      'ZM': 'Zambia',
      'ZW': 'Zimbabwe'
    };
    $scope.currenciesCode = [
      'EUR',
      'AED',
      'AFN',
      'ALL',
      'AMD',
      'ANG',
      'AOA',
      'ARS',
      'AUD',
      'AWG',
      'AZN',
      'BAM',
      'BBD',
      'BDT',
      'BGN',
      'BHD',
      'BIF',
      'BMD',
      'BND',
      'BOB',
      'BRL',
      'BSD',
      'BWP',
      'BYR',
      'BZD',
      'CAD',
      'CHF',
      'CLP',
      'CNY',
      'COP',
      'CRC',
      'CUP',
      'CVE',
      'CZK',
      'DJF',
      'DKK',
      'DOP',
      'DZD',
      'EGP',
      'ERN',
      'ETB',
      'FJD',
      'FKP',
      'GBP',
      'GEL',
      'GHS',
      'GIP',
      'GMD',
      'GNF',
      'GTQ',
      'GYD',
      'HKD',
      'HNL',
      'HRK',
      'HUF',
      'IDR',
      'ILS',
      'INR',
      'IQD',
      'IRR',
      'ISK',
      'JMD',
      'JOD',
      'JPY',
      'KES',
      'KGS',
      'KHR',
      'KMF',
      'KPW',
      'KRW',
      'KWD',
      'KYD',
      'KZT',
      'LAK',
      'LBP',
      'LKR',
      'LRD',
      'LYD',
      'MAD',
      'MDL',
      'MGA',
      'MKD',
      'MMK',
      'MNT',
      'MOP',
      'MRO',
      'MUR',
      'MVR',
      'MWK',
      'MXN',
      'MYR',
      'MZN',
      'NGN',
      'NIO',
      'NOK',
      'NPR',
      'NZD',
      'OMR',
      'PEN',
      'PGK',
      'PHP',
      'PKR',
      'PLN',
      'PYG',
      'QAR',
      'RON',
      'RSD',
      'RUB',
      'RWF',
      'SAR',
      'SBD',
      'SCR',
      'SDG',
      'SEK',
      'SGD',
      'SHP',
      'SLL',
      'SOS',
      'SRD',
      'SSP',
      'STD',
      'SYP',
      'SZL',
      'THB',
      'TJS',
      'TMT',
      'TND',
      'TOP',
      'TRY',
      'TTD',
      'TWD',
      'TZS',
      'UAH',
      'UGX',
      'USD',
      'UYU',
      'UZS',
      'VEF',
      'VND',
      'VUV',
      'WST',
      'XAF',
      'XCD',
      'XOF',
      'XPF',
      'YER',
      'ZAR',
      'ZMW',
      'ZWL',
    ];
    $scope.tipoResaValues = {
      'EXW': 'Ex-Works',
      'FCA': 'Free Carrier',
      'CPT': 'Carriage Paid To',
      'CIP': 'Carriage and Insurance Paid',
      'DAT': 'Delivered at Terminal',
      'DAP': 'Delivered at Place',
      'DDP': 'Delivered Duty Paid',
      'FAS': 'Free alongside Ship',
      'FOB': 'Free On Board',
      'CFR': 'Cost and Freight',
      'CIF': 'Cost, Insurance and Freight'
    };
    // </editor-fold>

    // <editor-fold desc='Set some values from user data when is filling a new invoice'>

    // we set these values to false in controller because they can't be set just in view
    // as they may be changed in getDataFromUser
    // their initialization in view was removed
    $scope.isOpenOneTwoOneFour = false;
    $scope.IscrizioneREAIsIncluded = false;
    $scope.isOpenOneThree = false;
    $scope.isOpenOneThreeOne = false;
    $scope.isOpenOneThreeOneOne = false;
    $scope.isOpenOneThreeOneTwo = false;
    $scope.RappresentanteFiscaleIsIncluded = false;
    $scope.isOpenOneTwoOneThree = false;
    $scope.StabileOrganizzazioneIsIncluded = false;
    $scope.backupCedentePrestatoreIdCodice = '';
    $scope.backupCedentePrestatoreCodicePaese = '';
    $scope.backupCedentePrestatoreFiscalCode = '';
    $scope.backupFirstName = '';
    $scope.backupSurname = '';
    $scope.backupName = '';
    $scope.backupTitolo = '';
    $scope.backupCodEORI = '';
    //$scope.backupAlboProfessionale = '';
    //$scope.backupProvinciaAlbo = '';
    //$scope.backupNumeroIscrizioneAlbo = '';
    //$scope.backupDataIscrizioneAlbo = '';
    $scope.backupAddress = '';
    $scope.backupNumeroCivico = '';
    $scope.backupCAP = '';
    $scope.backupCity = '';
    $scope.backupProvinceCode = '';
    $scope.backupCodicePaese = '';
    //$scope.backupAlboProfessionaleIncluded = false;
    //$scope.backupRegimeFiscale = '';

    let getDataFromUser = () => {
      ArchiSmallServices.getUser($rootScope.currentUser().sub)
        .then((response: any) => {
          $rootScope.user = response;
          store.set('user', response);
          let userOrganizationData = (jQuery.extend(true, {}, response.organizationData));
          // datiAnagrafici
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice = userOrganizationData.PIVA;
          $scope.backupCedentePrestatoreIdCodice = userOrganizationData.PIVA;
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese = userOrganizationData.codicePaese;
          $scope.backupCedentePrestatoreCodicePaese = userOrganizationData.codicePaese;
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.CodiceFiscale = userOrganizationData.fiscalCode;
          $scope.backupCedentePrestatoreFiscalCode = userOrganizationData.fiscalCode;

          if (response.accountData.userType === 1) {
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Nome = userOrganizationData.contactPerson.firstname;
            $scope.backupFirstName = userOrganizationData.contactPerson.firstname;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Cognome = userOrganizationData.contactPerson.surname;
            $scope.backupSurname = userOrganizationData.contactPerson.surname;
          } else {
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione = userOrganizationData.name;
            $scope.backupName = userOrganizationData.name;
          }
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Titolo = userOrganizationData.titolo;
          $scope.backupTitolo = userOrganizationData.titolo;
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.CodEORI = userOrganizationData.codEORI;
          $scope.backupCodEORI = userOrganizationData.codEORI;

          // alboProfessionale
          if (userOrganizationData.alboProfessionaleIncluded) {
            let userAlboProfessionale = userOrganizationData.alboProfessionale;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.AlboProfessionale = userAlboProfessionale.alboProfessionale;
            //$scope.backupAlboProfessionale = userAlboProfessionale.alboProfessionale;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.ProvinciaAlbo = userAlboProfessionale.provinciaAlbo;
            //$scope.backupProvinciaAlbo = userAlboProfessionale.provinciaAlbo;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.NumeroIscrizioneAlbo = userAlboProfessionale.numeroIscrizioneAlbo;
            //$scope.backupNumeroIscrizioneAlbo = userAlboProfessionale.numeroIscrizioneAlbo;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.DataIscrizioneAlbo = $rootScope.formatDateValue(userAlboProfessionale.dataIscrizioneAlbo);
            //$scope.backupDataIscrizioneAlbo = $rootScope.formatDateValue(userAlboProfessionale.dataIscrizioneAlbo);
          }

          // inscrizioneREA
          if (userOrganizationData.inscrizioneREAIncluded) {
            let userIscrizioneREA = userOrganizationData.inscrizioneREA;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.Ufficio = userIscrizioneREA.ufficio;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.NumeroREA = userIscrizioneREA.numeroREA;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.CapitaleSociale = userIscrizioneREA.capitaleSociale;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.SocioUnico = userIscrizioneREA.socioUnico;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.StatoLiquidazione = userIscrizioneREA.statoLiquidazione;
            $scope.isOpenOneTwoOneFour = true;
            $scope.IscrizioneREAIsIncluded = true;
          }


          // rappresentanteFiscale
          if (userOrganizationData.rappresentanteFiscaleIncluded) {
            let rappresentanteFiscale = (jQuery.extend(true, {}, RappresentanteFiscaleItem));
            let userRappresentanteFiscale = userOrganizationData.rappresentanteFiscale;
            rappresentanteFiscale.DatiAnagrafici.IdFiscaleIVA.IdPaese = userRappresentanteFiscale.codicePaese;
            rappresentanteFiscale.DatiAnagrafici.IdFiscaleIVA.IdCodice = userRappresentanteFiscale.PIVA;
            rappresentanteFiscale.DatiAnagrafici.CodiceFiscale = userRappresentanteFiscale.fiscalCode;
            rappresentanteFiscale.DatiAnagrafici.Anagrafica.Denominazione = userRappresentanteFiscale.denominazione;
            rappresentanteFiscale.DatiAnagrafici.Anagrafica.Titolo = userRappresentanteFiscale.titolo;
            rappresentanteFiscale.DatiAnagrafici.Anagrafica.Nome = userRappresentanteFiscale.nome;
            rappresentanteFiscale.DatiAnagrafici.Anagrafica.Cognome = userRappresentanteFiscale.cognome;
            rappresentanteFiscale.DatiAnagrafici.Anagrafica.CodEORI = userRappresentanteFiscale.codEORI;
            $scope.FatturaPA.FatturaElettronicaHeader.RappresentanteFiscale = rappresentanteFiscale;
            $scope.isOpenOneThree = true;
            $scope.isOpenOneThreeOne = true;
            $scope.isOpenOneThreeOneOne = true;
            $scope.isOpenOneThreeOneTwo = true;
            $scope.RappresentanteFiscaleIsIncluded = true;
          }

          // sede

          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Indirizzo = userOrganizationData.address;
          $scope.backupAddress = userOrganizationData.address;
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.NumeroCivico = userOrganizationData.numeroCivico;
          $scope.backupNumeroCivico = userOrganizationData.numeroCivico;
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.CAP = userOrganizationData.CAP;
          $scope.backupCAP = userOrganizationData.CAP;
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Comune = userOrganizationData.city;
          $scope.backupCity = userOrganizationData.city;
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia = userOrganizationData.provinceCode;
          $scope.backupProvinceCode = userOrganizationData.provinceCode;
          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione = userOrganizationData.codicePaese;
          $scope.backupCodicePaese = userOrganizationData.codicePaese;
          // end sede

          // stabileOrganizzazione
          if (userOrganizationData.stabileOrganizzazioneAddressIsDifferent) {
            let userStabileOrganizzazione = userOrganizationData.stabileOrganizzazione;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Indirizzo = userStabileOrganizzazione.address;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.NumeroCivico = userStabileOrganizzazione.numeroCivico;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.CAP = userStabileOrganizzazione.CAP;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Comune = userStabileOrganizzazione.city;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Provincia = userStabileOrganizzazione.provinceCode;
            $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Nazione = userStabileOrganizzazione.codicePaese;
            $scope.isOpenOneTwoOneThree = true;
            $scope.StabileOrganizzazioneIsIncluded = true;
          }

          $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.RegimeFiscale = userOrganizationData.regimeFiscale;
          //$scope.backupRegimeFiscale = userOrganizationData.regimeFiscale;
          $rootScope.loading = false;
        }, (error) => {
          $rootScope.alert('error', error);
          $rootScope.loading = false;
        });
    };
    // </editor-fold>

    let extractFatturaDataFromItem = (item) => {
      $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente = this.getEmptyCessionarioCommittente();

      let codiceDestinatario = '';

      if (item.codice_destinatario !== undefined && item.codice_destinatario !== '') {
        codiceDestinatario = item.codice_destinatario;
      } else {
        codiceDestinatario = '0000000';
      }

      if (codiceDestinatario === '0000000') {
        $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = item.email_pec;
      } else {
        $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = '';
      }

      $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = codiceDestinatario;

      let denominazione = '';

      if (item.type === 1) {
        denominazione = item.nome + ' ' + item.cognome;
      } else {
        denominazione = item.company_name;
      }

      $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione = denominazione.substring(0, 80);

      $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Indirizzo = item['indirizzo'];
      $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.CAP = item['cap'];
      $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Comune = item['comune'];
      $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia = item['provincia'];
      $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione = item['id_nazione'] || 'IT';

      if (item.fiscal_code !== undefined && item.fiscal_code !== '') {
        $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale = item['fiscal_code'];
      }

      if (item.piva !== undefined && item.piva !== '') {
        $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdCodice = item.piva;
        $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese = item.id_paese;
      }

      $scope.addDatiPagamento(0);
      $scope.FatturaPA.FatturaElettronicaBody[0].DatiPagamento[0].DettaglioPagamento[0].ModalitaPagamento = item['payment_mode'] || 'MP05';
      $scope.FatturaPA.FatturaElettronicaBody[0].DatiPagamento[0].DettaglioPagamento[0].IBAN = item['iban'] || '';
    };


    // load default object
    $scope.DettaglioLineeIsIncluded = [];
    $scope.DatiRiepilogoIsIncluded = [];
    $scope.FatturaPA = FatturaPA.FatturaPA;
    let oneFatturaElettronicaBodyItem = FatturaElettronicaBodyItem;
    //  oneFatturaElettronicaBodyItem.DatiBeniServizi.DettaglioLinee.push(jQuery.extend(true, {}, DettaglioLineeItem));
    oneFatturaElettronicaBodyItem.DatiBeniServizi.DatiRiepilogo.push(jQuery.extend(true, {}, DatiRiepilogoItem));
    $scope.FatturaPA.FatturaElettronicaBody.push(jQuery.extend(true, {}, oneFatturaElettronicaBodyItem));
    $scope.DettaglioLineeIsIncluded[0] = true;
    $scope.DatiRiepilogoIsIncluded[0] = true;
    getDataFromUser();
    // end load default object

    if ($stateParams.xmlpath !== '') {
      // get Invoice  $stateParams.xmlpath

      ng.element(document).ready(() => {
        ArchiSmallServices.getFatturaPA($stateParams.xmlpath)
          .then((response: any) => {
            if (response.FatturaPAXML !== undefined) {
              $scope.loadExistingXml(response.FatturaPAXML);
              if ($stateParams.requestNotaCredito) {
                $scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.TipoDocumento = 'TD04';
              }
            }
          }, (error) => {
            $rootScope.alert('error', error);
          });
      });
    }

    $scope.openSelectRubricaModal = () => {
      let modalInstance = $uibModal.open({
        animation: true,
        component: 'rubricaSearchPRModalComponent',
        size: 'lg',
      });

      modalInstance.result.then((item) => {
        if (item !== undefined) {
          extractFatturaDataFromItem(item);
          $scope.destinatarioItem = item;
        }
      }, () => {
        // ?
      });
    };

    $scope.openInsertRubricaModal = () => {
      let modalInstance = $uibModal.open({
        animation: true,
        component: 'rubricaInsertPRModalComponent',
        size: 'lg',
      });

      modalInstance.result.then((item) => {
        if (item !== undefined) {
          extractFatturaDataFromItem(item);
          $scope.destinatarioItem = item;
        }
      }, () => {
        // ?
      });
    };

    $scope.loadExternalXml = (element) => {
      if (element.files.length === 1) {
        let extension = element.files[0].name.split('.').pop().toLowerCase();
        if (extension !== 'xml') {
          $rootScope.alert('error', 'Only xml files are accpted!');
          return;
        }

        let reader = new FileReader();
        reader.onloadend = () => {
          $scope.loadExistingXml(reader.result);
        };
        reader.readAsText(element.files[0]);
        let $input = $(element);
        let _$input: any = $input.wrap('<form>').closest('form').get(0);
        _$input.reset();
        $input.unwrap();
      }

    };
    $scope.loadExistingXml = (stringXml) => {
      try {

        let fatturaPA: any;
        let parser = new xml2js.Parser({explicitRoot: false, explicitArray: false});
        parser.parseString(stringXml, (err, result) => {
          fatturaPA = result;
        });
        fatturaPA.FatturaElettronicaBody = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody);
        for (let i = 0; i < fatturaPA.FatturaElettronicaBody.length; i++) {
          if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali !== undefined) {
            fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale);
            fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta);
            fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione);
            fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.Causale = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiGeneraliDocumento.Causale, 'Causale');
            if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiOrdineAcquisto !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiOrdineAcquisto = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiOrdineAcquisto);
              for (let datiOrdineAcquistoIndex = 0; datiOrdineAcquistoIndex < fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiOrdineAcquisto.length; datiOrdineAcquistoIndex++) {
                if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiOrdineAcquisto[datiOrdineAcquistoIndex].RiferimentoNumeroLinea !== undefined) {
                  fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiOrdineAcquisto[datiOrdineAcquistoIndex].RiferimentoNumeroLinea = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiOrdineAcquisto[datiOrdineAcquistoIndex].RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                }
              }
            }

            if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiContratto !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiContratto = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiContratto);
              for (let datiContrattoIndex = 0; datiContrattoIndex < fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiContratto.length; datiContrattoIndex++) {
                if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiContratto[datiContrattoIndex].RiferimentoNumeroLinea !== undefined) {
                  fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiContratto[datiContrattoIndex].RiferimentoNumeroLinea = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiContratto[datiContrattoIndex].RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                }
              }
            }

            if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiConvenzione !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiConvenzione = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiConvenzione);
              for (let datiConvenzioneIndex = 0; datiConvenzioneIndex < fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiConvenzione.length; datiConvenzioneIndex++) {
                if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiConvenzione[datiConvenzioneIndex].RiferimentoNumeroLinea !== undefined) {
                  fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiConvenzione[datiConvenzioneIndex].RiferimentoNumeroLinea = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiConvenzione[datiConvenzioneIndex].RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                }
              }
            }

            if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiRicezione !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiRicezione = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiRicezione);
              for (let datiRicezioneIndex = 0; datiRicezioneIndex < fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiRicezione.length; datiRicezioneIndex++) {
                if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiRicezione[datiRicezioneIndex].RiferimentoNumeroLinea !== undefined) {
                  fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiRicezione[datiRicezioneIndex].RiferimentoNumeroLinea = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiRicezione[datiRicezioneIndex].RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                }
              }
            }

            if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate);
              for (let datiFattureCollegateIndex = 0; datiFattureCollegateIndex < fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate.length; datiFattureCollegateIndex++) {
                if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate[datiFattureCollegateIndex].RiferimentoNumeroLinea !== undefined) {
                  fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate[datiFattureCollegateIndex].RiferimentoNumeroLinea = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiFattureCollegate[datiFattureCollegateIndex].RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                }
              }
            }

            if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiSAL !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiSAL = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiSAL);
            }

            if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT);
              for (let datiDDTIndex = 0; datiDDTIndex < fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT.length; datiDDTIndex++) {
                if (fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT[datiDDTIndex].RiferimentoNumeroLinea !== undefined) {
                  fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT[datiDDTIndex].RiferimentoNumeroLinea = $scope.makeSureIsArrayOfObjects(fatturaPA.FatturaElettronicaBody[i].DatiGenerali.DatiDDT[datiDDTIndex].RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
                }
              }
            }
          }

          if (fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi !== undefined) {
            fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DatiRiepilogo = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DatiRiepilogo);
            if (fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee !== undefined) {
              fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee);
              for (let dettaglioLineeIndex = 0; dettaglioLineeIndex < fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee.length; dettaglioLineeIndex++) {
                fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].CodiceArticolo = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].CodiceArticolo);
                fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].ScontoMaggiorazione = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].ScontoMaggiorazione);
                fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].AltriDatiGestionali = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiBeniServizi.DettaglioLinee[dettaglioLineeIndex].AltriDatiGestionali);
              }
            }
          }

          if (fatturaPA.FatturaElettronicaBody[i].DatiPagamento !== undefined) {
            fatturaPA.FatturaElettronicaBody[i].DatiPagamento = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiPagamento);
            for (let datiPagamentoIndex = 0; datiPagamentoIndex < fatturaPA.FatturaElettronicaBody[i].DatiPagamento.length; datiPagamentoIndex++) {
              if (fatturaPA.FatturaElettronicaBody[i].DatiPagamento[datiPagamentoIndex].DettaglioPagamento !== undefined) {
                fatturaPA.FatturaElettronicaBody[i].DatiPagamento[datiPagamentoIndex].DettaglioPagamento = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].DatiPagamento[datiPagamentoIndex].DettaglioPagamento);
              }
            }
          }

          if (fatturaPA.FatturaElettronicaBody[i].Allegati !== undefined) {
            fatturaPA.FatturaElettronicaBody[i].Allegati = $scope.makeSureIsArray(fatturaPA.FatturaElettronicaBody[i].Allegati);
          }
        }

        $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = fatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario;
        $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = fatturaPA.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario;
        $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente = fatturaPA.FatturaElettronicaHeader.CessionarioCommittente;
        $scope.FatturaPA.FatturaElettronicaBody = fatturaPA.FatturaElettronicaBody;
      } catch (ex) {
        $rootScope.alert('error', 'We could not load the xml content. Please make sure it contains the correct format !');
      }

      try {

        $scope.refreshSedeStates();
        $scope.refreshStabileStateCodes();
        $scope.refreshCessionarioCommittenteStateCodes();
        $scope.refreshStateCodes();
        $scope.refreshCities();
        $scope.refreshStabileCities();
        $scope.refreshCessionarioCommittenteCities();
      } catch (ex) {
        $rootScope.alert('error', ex);
      }
    };
    $scope.makeSureIsArray = (possibleObject) => {

      let oldObject = possibleObject;
      possibleObject = [];
      if (oldObject !== null && (typeof oldObject === 'object' || typeof oldObject === 'string')) {
        if (Object.prototype.toString.call(oldObject) === '[object Array]') {
          return oldObject;
        }

        possibleObject.push(oldObject);
      }
      return possibleObject;
    };
    $scope.makeSureIsArrayOfObjects = (possibleObject, objectName) => {
      let oldObject = possibleObject;
      let newObject = [];
      if (oldObject !== null) {
        switch (typeof oldObject) {
          case 'object':
            if (Object.prototype.toString.call(oldObject) === '[object Array]') {
              for (let i = 0; i < oldObject.length; i++) {
                let item = {};
                item[objectName] = oldObject[i];
                newObject.push(item);
              }
              return newObject;
            }
            break;
          case 'string':
            let item = {};
            item[objectName] = oldObject;
            newObject.push(item);
            break;
          default:
            return newObject;
        }
      }
      return newObject;
    };
    $scope.editDettaglioLineeItem = (fatturaElettronicaBodyItemIndex, item) => {

      let isNew = false;
      if (item === null || item === undefined) {
        isNew = true;
        item = jQuery.extend(true, {}, DettaglioLineeItem);
        let countDettaglioLinee = $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiBeniServizi.DettaglioLinee.length;
        let lastDettaglioLineeNumero = 0;
        if (countDettaglioLinee > 0) {
          lastDettaglioLineeNumero = $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiBeniServizi.DettaglioLinee[countDettaglioLinee - 1].NumeroLinea;
        }
        item.NumeroLinea = parseInt(lastDettaglioLineeNumero.toString(), 0) + 1;
      }

      let dettaglioLineeModal = $uibModal.open({
        animation: true,
        component: 'dettaglioLineePRModalComponent',
        windowClass: '',
        backdrop: 'static',
        size: 'lg',
        keyboard: false,
        resolve: {
          settings: {
            'item': item,
            'fatturaElettronicaBodyItemIndex': fatturaElettronicaBodyItemIndex
          }
        }
      });
      dettaglioLineeModal.result.then((updatedDettaglioLineeItem) => {
        // updatedDettaglioLineeItem = updatedDettaglioLineeItem;
        if (isNew && updatedDettaglioLineeItem != null) {
          $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiBeniServizi.DettaglioLinee.push(item);
        }
      }, () => {
        // ?
      });
    };
    // <editor-fold desc='Fattura ElettronicaHeader'>
    $scope.IdFiscaleIVAIsIncluded = false;
    $scope.addIdFiscaleIVA = () => {
      $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA = (jQuery.extend(true, {}, IdFiscaleIVAItem));
      $scope.IdFiscaleIVAIsIncluded = true;
    };
    $scope.removeIdFiscaleIVA = () => {
      $scope.IdFiscaleIVAIsIncluded = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA = {};
      }, 1);
    };
    $scope.addContatti = () => {
      $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Contatti = (jQuery.extend(true, {}, ContattiItem));
    };
    $scope.removeContatti = () => {
      $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Contatti = {};
    };
    $scope.IscrizioneREAIsIncluded = false;
    $scope.addIscrizioneREA = () => {
      $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA = (jQuery.extend(true, {}, IscrizioneREAItem));
      $scope.IscrizioneREAIsIncluded = true;
    };
    $scope.removeIscrizioneREA = () => {
      $scope.IscrizioneREAIsIncluded = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA = {};
      }, 1);
    };
    $scope.StabileOrganizzazioneIsIncluded = false;
    $scope.addStabileOrganizzazione = () => {
      $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione = (jQuery.extend(true, {}, StabileOrganizzazioneItem));
      $scope.StabileOrganizzazioneIsIncluded = true;
    };
    $scope.removeStabileOrganizzazione = () => {
      $scope.StabileOrganizzazioneIsIncluded = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione = {};
      }, 1);
    };
    $scope.addContattiTrasmittente = () => {
      $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.ContattiTrasmittente = (jQuery.extend(true, {}, ContattiTrasmittenteItem));
    };
    $scope.removeContattiTrasmittente = () => {
      $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.ContattiTrasmittente = {};
    };
    $scope.RappresentanteFiscaleIsIncluded = false;
    $scope.addRappresentanteFiscale = () => {
      $scope.FatturaPA.FatturaElettronicaHeader.RappresentanteFiscale = (jQuery.extend(true, {}, RappresentanteFiscaleItem));
      $scope.RappresentanteFiscaleIsIncluded = true;
    };
    $scope.removeRappresentanteFiscale = () => {
      $scope.RappresentanteFiscaleIsIncluded = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaHeader.RappresentanteFiscale = {};
      }, 1);
    };

    // <editor-fold desc='FatturaElettronicaBody'>
    $scope.addFatturaElettronicaBody = () => {
      $scope.FatturaPA.FatturaElettronicaBody.push(jQuery.extend(true, {}, FatturaElettronicaBodyItem));
    };
    $scope.removeFatturaElettronicaBody = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody.splice(fatturaElettronicaBodyItemIndex, 1);
    };
    $scope.DatiRitenutaIsIncluded = [];
    $scope.addDatiRitenuta = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.push(jQuery.extend(true, {}, DatiRitenutaItem));
      $scope.DatiRitenutaIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDatiRitenuta = (fatturaElettronicaBodyItemIndex, datiRitenutaItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length - 1 === 0) {
        $scope.DatiRitenutaIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.splice(datiRitenutaItemIndex, 1);
      }, 1);
    };
    $scope.DatiBolloIsIncluded = [];
    $scope.addDatiBollo = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.DatiBollo = (jQuery.extend(true, {}, DatiBolloItem));
      $scope.DatiBolloIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDatiBollo = (fatturaElettronicaBodyItemIndex) => {
      $scope.DatiBolloIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.DatiBollo = {};
      }, 1);
    };
    $scope.CassaPrevidenzialeIsIncluded = [];
    $scope.addCassaPrevidenziale = (fatturaElettronicaBodyItemIndex) => {
      $scope.CassaPrevidenzialeIsIncluded[fatturaElettronicaBodyItemIndex] = true;
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.push(jQuery.extend(true, {}, DatiCassaPrevidenzialeItem));
    };
    $scope.removeCassaPrevidenziale = (fatturaElettronicaBodyItemIndex, datiCassaPrevidenzialeItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length - 1 === 0) {
        $scope.CassaPrevidenzialeIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.splice(datiCassaPrevidenzialeItemIndex, 1);
      }, 1);
    };
    $scope.ScontoMaggiorazioneDatiGeneraliDocumentoIsIncluded = [];
    $scope.addScontoMaggiorazioneDatiGeneraliDocumento = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione.push(jQuery.extend(true, {}, ScontoMaggiorazioneItem));
      $scope.ScontoMaggiorazioneDatiGeneraliDocumentoIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeScontoMaggiorazioneDatiGeneraliDocumento = (fatturaElettronicaBodyItemIndex, scontoMaggiorazioneItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione.length - 1 === 0) {
        $scope.ScontoMaggiorazioneDatiGeneraliDocumentoIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione.splice(scontoMaggiorazioneItemIndex, 1);
      }, 1);
    };
    $scope.CausaleIsIncluded = [];
    $scope.addCausaleItem = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.Causale.push(jQuery.extend(true, {}, CausaleItem));
      $scope.CausaleIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeCausaleItem = (fatturaElettronicaBodyItemIndex, CausaleItemIndex) => {

      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.Causale.length - 1 === 0) {
        $scope.CausaleIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.Causale.splice(CausaleItemIndex, 1);
      }, 1);
    };
    $scope.removeImportoTotaleDocumento = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento = undefined;
    };
    $scope.DatiIsIncluded = [];
    $scope.addDati = (fatturaElettronicaBodyItemIndex, Dati) => {
      let itemsContainer: any = {};
      itemsContainer.DatiOrdineAcquisto = DatiOrdineAcquistoItem;
      itemsContainer.DatiContratto = DatiContrattoItem;
      itemsContainer.DatiConvenzione = DatiConvenzioneItem;
      itemsContainer.DatiRicezione = DatiRicezioneItem;
      itemsContainer.DatiFattureCollegate = DatiFattureCollegateItem;
      // we need to create the property
      // because on loading Xml case the JSON contains
      // only populated properties
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali[Dati] === undefined) {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali[Dati] = [];
      }
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali[Dati].push(jQuery.extend(true, {}, itemsContainer[Dati]));
      $scope.DatiIsIncluded[Dati + fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDati = (fatturaElettronicaBodyItemIndex, Dati, DatiItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali[Dati].length - 1 === 0) {
        $scope.DatiIsIncluded[Dati + fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali[Dati].splice(DatiItemIndex, 1);
      }, 1);
    };
    $scope.DatiSALIsIncluded = [];
    $scope.addDatiSAL = (fatturaElettronicaBodyItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiSAL === undefined) {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiSAL = [];
      }
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiSAL.push(jQuery.extend(true, {}, DatiSALItem));
      $scope.DatiSALIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDatiSAL = (fatturaElettronicaBodyItemIndex, DatiSALItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiSAL.length - 1 === 0) {
        $scope.DatiSALIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiSAL.splice(DatiSALItemIndex, 1);
      }, 1);
    };
    $scope.DatiDDTIsIncluded = [];
    $scope.addDatiDDT = (fatturaElettronicaBodyItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiDDT === undefined) {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiDDT = [];
      }
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiDDT.push(jQuery.extend(true, {}, DatiDDTItem));
      $scope.DatiDDTIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDatiDDT = (fatturaElettronicaBodyItemIndex, DatiDDTItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiDDT.length - 1 === 0) {
        $scope.DatiDDTIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiDDT.splice(DatiDDTItemIndex, 1);
      }, 1);
    };
    $scope.DatiPagamentoIsIncluded = [];
    let datiIndex = 0;
    $scope.addDatiPagamento = (fatturaElettronicaBodyItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiPagamento === undefined) {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiPagamento = [];
      }
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiPagamento.push(jQuery.extend(true, {}, DatiPagamentoItem));
      $scope.DatiPagamentoIsIncluded['DatiPagamentoItem' + fatturaElettronicaBodyItemIndex] = true;
      $scope.DettaglioPagamentoIsIncluded['DettaglioPagamentoItem' + datiIndex + fatturaElettronicaBodyItemIndex] = true;
      datiIndex++;
    };
    $scope.removeDatiPagamento = (fatturaElettronicaBodyItemIndex, DatiPagamentoItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiPagamento.length - 1 === 0) {
        $scope.DatiPagamentoIsIncluded['DatiPagamentoItem' + fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiPagamento.splice(DatiPagamentoItemIndex, 1);
      }, 1);
    };
    $scope.addDettaglioPagamento = (fatturaElettronicaBodyItemIndex, DatiPagamentoItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiPagamento[DatiPagamentoItemIndex].DettaglioPagamento.push(jQuery.extend(true, {}, DettaglioPagamentoItem));
      $scope.DettaglioPagamentoIsIncluded['DettaglioPagamentoItem' + DatiPagamentoItemIndex + fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDettaglioPagamento = (fatturaElettronicaBodyItemIndex, DatiPagamentoItemIndex, DettaglioPagamentoItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiPagamento[DatiPagamentoItemIndex].DettaglioPagamento.length - 1 === 0) {
        $scope.DettaglioPagamentoIsIncluded['DettaglioPagamentoItem' + DatiPagamentoItemIndex + fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiPagamento[DatiPagamentoItemIndex].DettaglioPagamento.splice(DettaglioPagamentoItemIndex, 1);
      }, 1);
    };
    $scope.removeRiferimentoNumeroLinea = (fatturaElettronicaBodyItemIndex, Dati, DatiItemIndex, RiferimentoNumeroLineaItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali[Dati][DatiItemIndex].RiferimentoNumeroLinea.splice(RiferimentoNumeroLineaItemIndex, 1);
    };
    $scope.addRiferimentoNumeroLinea = (fatturaElettronicaBodyItemIndex, Dati, DatiItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali[Dati][DatiItemIndex].RiferimentoNumeroLinea === undefined) {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali[Dati][DatiItemIndex].RiferimentoNumeroLinea = [];
      }
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali[Dati][DatiItemIndex].RiferimentoNumeroLinea.push(jQuery.extend(true, {}, RiferimentoNumeroLineaItem));
    };
    $scope.removeDettaglioLinee = (fatturaElettronicaBodyItemIndex, DettaglioLineeItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiBeniServizi.DettaglioLinee.length - 1 === 0) {
        $scope.DettaglioLineeIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiBeniServizi.DettaglioLinee.splice(DettaglioLineeItemIndex, 1);
      }, 1);
    };
    $scope.addDatiRiepilogo = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiBeniServizi.DatiRiepilogo.push(jQuery.extend(true, {}, DatiRiepilogoItem));
      $scope.DatiRiepilogoIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDatiRiepilogo = (fatturaElettronicaBodyItemIndex, DatiRiepilogoItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiBeniServizi.DatiRiepilogo.length - 1 === 0) {
        $scope.DatiRiepilogoIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiBeniServizi.DatiRiepilogo.splice(DatiRiepilogoItemIndex, 1);
      }, 1);
    };
    $scope.DatiTrasportoIsIncluded = [];
    $scope.addDatiTrasporto = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiTrasporto = (jQuery.extend(true, {}, DatiTrasportoItem));
      $scope.DatiTrasportoIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDatiTrasporto = (fatturaElettronicaBodyItemIndex) => {
      $scope.DatiTrasportoIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiTrasporto = {};
      }, 1);
    };
    $scope.DatiAnagraficiVettoreIsIncluded = [];
    $scope.addDatiAnagraficiVettore = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiTrasporto.DatiAnagraficiVettore = (jQuery.extend(true, {}, DatiAnagraficiVettoreItem));
      $scope.DatiAnagraficiVettoreIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDatiAnagraficiVettore = (fatturaElettronicaBodyItemIndex) => {
      $scope.DatiAnagraficiVettoreIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiTrasporto.DatiAnagraficiVettore = {};
      }, 1);
    };
    $scope.IndirizzoResaIsIncluded = [];
    $scope.addIndirizzoResa = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiTrasporto.IndirizzoResa = (jQuery.extend(true, {}, IndirizzoResaItem));
      $scope.IndirizzoResaIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeIndirizzoResa = (fatturaElettronicaBodyItemIndex) => {
      $scope.IndirizzoResaIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.DatiTrasporto.IndirizzoResa = {};
      }, 1);
    };
    $scope.FatturaPrincipaleIsIncluded = [];
    $scope.addFatturaPrincipale = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.FatturaPrincipale = (jQuery.extend(true, {}, FatturaPrincipaleItem));
      $scope.FatturaPrincipaleIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeFatturaPrincipale = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPrincipaleIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiGenerali.FatturaPrincipale = {};
      }, 1);
    };
    $scope.DatiVeicoliIsIncluded = [];
    $scope.addDatiVeicoli = (fatturaElettronicaBodyItemIndex) => {
      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiVeicoli = (jQuery.extend(true, {}, DatiVeicoliItem));
      $scope.DatiVeicoliIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeDatiVeicoli = (fatturaElettronicaBodyItemIndex) => {
      $scope.DatiVeicoliIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].DatiVeicoli = {};
      }, 1);
    };
    $scope.AllegatiIsIncluded = [];
    $scope.addAllegati = (fatturaElettronicaBodyItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].Allegati === undefined) {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].Allegati = [];
      }

      $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].Allegati.push(jQuery.extend(true, {}, AllegatiItem));
      $scope.AllegatiIsIncluded[fatturaElettronicaBodyItemIndex] = true;
    };
    $scope.removeAllegati = (fatturaElettronicaBodyItemIndex, AllegatiItemIndex) => {
      if ($scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].Allegati.length - 1 === 0) {
        $scope.AllegatiIsIncluded[fatturaElettronicaBodyItemIndex] = false;
      }

      $timeout(() => {
        $scope.FatturaPA.FatturaElettronicaBody[fatturaElettronicaBodyItemIndex].Allegati.splice(AllegatiItemIndex, 1);
      }, 1);
    };
    // </editor-fold>

    // <editor-fold desc='readFileCallback'>
    $scope.readFileCallback = (dropzone, filename, contentBase64) => {
      if (dropzone !== false) {
        let res = dropzone.split('-');
        // total size of attachment check
        let attachmentSize = contentBase64.length;
        for (let indexFatturaElettronicaBody = 0; indexFatturaElettronicaBody < $scope.FatturaPA.FatturaElettronicaBody.length; indexFatturaElettronicaBody++) {
          if ($scope.FatturaPA.FatturaElettronicaBody[indexFatturaElettronicaBody].Allegati !== undefined) {
            for (let indexAllegati = 0; indexAllegati < $scope.FatturaPA.FatturaElettronicaBody[indexFatturaElettronicaBody].Allegati.length; indexAllegati++) {
              attachmentSize += $scope.FatturaPA.FatturaElettronicaBody[indexFatturaElettronicaBody].Allegati[indexAllegati].Attachment.length;
            }
          }
        }

        if (attachmentSize > $rootScope.fatturaPAAttachmentMaxSize) {
          $rootScope.alert('warning', 'I files allegati superano la dimensione massima accettata (2 MB).');
          return false;
        }
        // end total size of attachment check

        $timeout(() => {
          $scope.FatturaPA.FatturaElettronicaBody[res[1]].Allegati[res[2]].NomeAttachment = filename;
          $scope.FatturaPA.FatturaElettronicaBody[res[1]].Allegati[res[2]].FormatoAttachment = filename.split('.').pop();
          $scope.FatturaPA.FatturaElettronicaBody[res[1]].Allegati[res[2]].Attachment = contentBase64;
        });
      }
    };
    // </editor-fold>

    let collectData = (json, property) => {
      let new_array = [];
      if (json !== undefined) {
        json.forEach((entry) => {
          let value = entry[property];
          if (value !== undefined && value !== null) {
            new_array.push(value);
          }
        });
      }
      return new_array;
    };
    $scope.save = () => {

      $scope.extractPecAndCodiceDestinatario();
      let fatturaPA = jQuery.extend(true, {}, $scope.FatturaPA);

      // validation
      for (let index = 0; index < fatturaPA.FatturaElettronicaBody.length; index++) {
        if (fatturaPA.FatturaElettronicaBody[index].DatiBeniServizi.DettaglioLinee.length === 0) {
          $rootScope.alert('error', 'Prego compilare Dettaglio Linee a Corpo Fattura (' + (index + 1) + ')!');
          return;
        }
      }
      // end validation

      $rootScope.loading = true;
      // <editor-fold desc='format json'>
      fatturaPA.FatturaElettronicaBody.forEach((fatturaElettronicaBody) => {
        if (fatturaElettronicaBody.DatiGenerali !== undefined) {
          // causale
          if (fatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento !== undefined) {
            let datiGeneraliDocumentoCausale = collectData(fatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale, 'Causale');
            fatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale = datiGeneraliDocumentoCausale;
          }

          // datiOrdineAcquisto
          if (fatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto !== undefined) {
            fatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto.forEach((datiOrdineAcquisto) => {
              let datiOrdineAcquistoRiferimentoNumeroLinea = collectData(datiOrdineAcquisto.RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
              datiOrdineAcquisto.RiferimentoNumeroLinea = datiOrdineAcquistoRiferimentoNumeroLinea;
            });
          }
          // datiContrattoAcquisto
          if (fatturaElettronicaBody.DatiGenerali.DatiContratto !== undefined) {
            fatturaElettronicaBody.DatiGenerali.DatiContratto.forEach((datiContratto) => {
              let datiContrattoRiferimentoNumeroLinea = collectData(datiContratto.RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
              datiContratto.RiferimentoNumeroLinea = datiContrattoRiferimentoNumeroLinea;
            });
          }
          // datiConvenzione
          if (fatturaElettronicaBody.DatiGenerali.DatiConvenzione !== undefined) {
            fatturaElettronicaBody.DatiGenerali.DatiConvenzione.forEach((datiConvenzione) => {
              let datiConvenzioneRiferimentoNumeroLinea = collectData(datiConvenzione.RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
              datiConvenzione.RiferimentoNumeroLinea = datiConvenzioneRiferimentoNumeroLinea;
            });
          }

          // datiRicezione
          if (fatturaElettronicaBody.DatiGenerali.DatiRicezione !== undefined) {
            fatturaElettronicaBody.DatiGenerali.DatiRicezione.forEach((datiRicezione) => {
              let datiRicezioneRiferimentoNumeroLinea = collectData(datiRicezione.RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
              datiRicezione.RiferimentoNumeroLinea = datiRicezioneRiferimentoNumeroLinea;
            });
          }

          // datiFattureCollegate
          if (fatturaElettronicaBody.DatiGenerali.DatiFattureCollegate !== undefined) {
            fatturaElettronicaBody.DatiGenerali.DatiFattureCollegate.forEach((datiFattureCollegate) => {
              let datiFattureCollegateRiferimentoNumeroLinea = collectData(datiFattureCollegate.RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
              datiFattureCollegate.RiferimentoNumeroLinea = datiFattureCollegateRiferimentoNumeroLinea;
            });
          }

          // datiDDT
          if (fatturaElettronicaBody.DatiGenerali.DatiDDT !== undefined) {
            fatturaElettronicaBody.DatiGenerali.DatiDDT.forEach((datiDDT) => {
              let datiDDTRiferimentoNumeroLinea = collectData(datiDDT.RiferimentoNumeroLinea, 'RiferimentoNumeroLinea');
              datiDDT.RiferimentoNumeroLinea = datiDDTRiferimentoNumeroLinea;
            });
          }
        }
      });
      // </editor-fold>

      let settings: any = {};
      settings.user = $rootScope.currentUser().sub;
      fatturaPA.FatturaElettronicaHeader.DatiTrasmissione.ProgressivoInvio = '0000000000';
      let builder1 = new xml2js.Builder(
        {
          renderOpts: {newline: ''},
          headless: true,
          rootName: 'FatturaElettronicaHeader'
        }
      );
      let builder2 = new xml2js.Builder(
        {
          renderOpts: {newline: ''},
          headless: true,
          rootName: 'FatturaElettronicaBody'
        }
      );
      fatturaPA.FatturaElettronicaBody.forEach(element => {
        if (element.Allegati && element.Allegati.length === 0) {
          element.Allegati.push('');
        }
        if (element.DatiPagamento && element.DatiPagamento.length === 0) {
          element.DatiPagamento.push('');
        }
        if (element.DatiBeniServizi && element.DatiBeniServizi.DettaglioLinee) {
          element.DatiBeniServizi.DettaglioLinee.forEach(el => {
            if (el.AliquotaIVA) {
              el.AliquotaIVA = Number(el.AliquotaIVA).toFixed(2);
            }
          });
        }
      });
      let _header = this.addEmptyArray(fatturaPA.FatturaElettronicaHeader);
      let _body = this.addEmptyArray(fatturaPA.FatturaElettronicaBody);
      settings.xml = builder1.buildObject(_header) + builder2.buildObject(_body);

      settings.formatoTrasmissione = fatturaPA.FatturaElettronicaHeader.DatiTrasmissione.FormatoTrasmissione;
      ArchiSmallServices.generateFatturaPA(settings)
        .then((response: any) => {
          if (response.Result === 1) {
            response.uploadType = 2;
            store.set('fatturazionepaComponiFattura-Result', response);
            $rootScope.loading = false;
            $state.go('home.pr-componi-fattura-confirm');
          }
        }, (error) => {
          $rootScope.loading = false;
          $rootScope.alert('error', error.data.errorDetails);
        });
    };

    $scope.extractPecAndCodiceDestinatario = () => {
      if ($scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario === undefined
        || $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario === '') {
        $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = '0000000';
      }

      if ($scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario !== '0000000') {
        $scope.FatturaPA.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario = '';
      }

    };
    // <editor-fold desc='Show Validation Errors'>
    setInterval(() => {
      $('div.panel').each(() => {
        if ($(this).find('.form-group.has-error').length > 0) {
          $(this).addClass('has-errors');
        } else {
          $(this).removeClass('has-errors');
        }

      });
    }, 1000);
    // </editor-fold>

    document.onscroll = () => {
      if (window.innerHeight + window.scrollY + 200 > document.body.clientHeight) {
        $('#sticked').hide();
      } else {
        $('#sticked').show();
      }
    };
    // <editor-fold desc='getTypeaheadValues'>
    $scope.refreshSedeStates = () => {
      let country = $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione;
      if (country) {
        ArchiSmallServices.getTypeaheadValues('stateCodes', 'country=' + country)
          .then((response: any) => {
            $scope.sedeStateCodes = response;
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.refreshStabileStateCodes = () => {
      let country = $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Nazione;
      if (country) {
        ArchiSmallServices.getTypeaheadValues('stateCodes', 'country=' + country)
          .then((response: any) => {
            $scope.stabileStateCodes = response;
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.refreshCessionarioCommittenteStateCodes = () => {
      let country = $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione;
      if (country) {
        ArchiSmallServices.getTypeaheadValues('stateCodes', 'country=' + country)
          .then((response: any) => {
            $scope.cessionarioCommittenteStateCodes = response;
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.refreshIndirizzoResaStateCodes = (index) => {
      let country = $scope.FatturaPA.FatturaElettronicaBody[index].DatiGenerali.DatiTrasporto.IndirizzoResa.Nazione;
      if (country) {
        ArchiSmallServices.getTypeaheadValues('stateCodes', 'country=' + country)
          .then((response: any) => {
            $scope.indirizzoResaStateCodes = response;
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.refreshStateCodes = () => {
      let country = 'IT';
      ArchiSmallServices.getTypeaheadValues('stateCodes', 'country=' + country)
        .then((response: any) => {
          $scope.stateCodes = response;
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.refreshCities = () => {
      let country = $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione;
      let state = $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia;
      if (country && state) {
        ArchiSmallServices.getTypeaheadValues('municipality-by-code', 'country=' + country + '&stateCode=' + state)
          .then((response: any) => {
            $scope.cities = response;
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.refreshStabileCities = () => {
      let country = $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Nazione;
      let state = ($scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione === undefined ||
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Provincia === undefined) ?
        '' : $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Provincia;
      if (country && state) {
        ArchiSmallServices.getTypeaheadValues('municipality-by-code', 'country=' + country + '&stateCode=' + state)
          .then((response: any) => {
            $scope.citiesStabile = response;
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.refreshCessionarioCommittenteCities = () => {
      let country = $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione;
      let state = ($scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede === undefined ||
        $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia === undefined) ?
        '' : $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia;
      if (country && state) {
        ArchiSmallServices.getTypeaheadValues('municipality-by-code', 'country=' + country + '&stateCode=' + state)
          .then((response: any) => {
            $scope.citiesCessionarioCommittente = response;
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.refreshIndirizzoResaCities = (index) => {
      let country = $scope.FatturaPA.FatturaElettronicaBody[index].DatiGenerali.DatiTrasporto.IndirizzoResa.Nazione;
      let state = ($scope.FatturaPA.FatturaElettronicaBody[index].DatiGenerali.DatiTrasporto.IndirizzoResa === undefined ||
        $scope.FatturaPA.FatturaElettronicaBody[index].DatiGenerali.DatiTrasporto.IndirizzoResa.Provincia === undefined) ?
        '' : $scope.FatturaPA.FatturaElettronicaBody[index].DatiGenerali.DatiTrasporto.IndirizzoResa.Provincia;
      if (country && state) {
        ArchiSmallServices.getTypeaheadValues('municipality-by-code', 'country=' + country + '&stateCode=' + state)
          .then((response: any) => {
            $scope.citiesIndirizzoResa = response;
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.getCAP = () => {
      let state = $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia;
      let city = $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Comune;
      if (state && city) {
        ArchiSmallServices.getTypeaheadValues('cap-by-code', 'stateCode=' + state + '&city=' + city)
          .then((response: any) => {
            // alert(response);
            if (response[0] !== '') {
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.CAP = response[0];
            }
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.getStabileCAP = () => {
      if ($scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione !== undefined &&
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Provincia !== undefined &&
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Comune !== undefined) {
        ArchiSmallServices.getTypeaheadValues('cap-by-code', 'stateCode=' + $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Provincia + '&city=' + $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Comune)
          .then((response: any) => {
            // alert(response);
            if (response[0] !== '') {
              $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.CAP = response[0];
            }
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.getCessionarioCommittenteCAP = () => {
      let state = $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia;
      let city = $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.Comune;
      if (state && city) {
        ArchiSmallServices.getTypeaheadValues('cap-by-code', 'stateCode=' + state + '&city=' + city)
          .then((response: any) => {
            // alert(response);
            if (response[0] !== '') {
              $scope.FatturaPA.FatturaElettronicaHeader.CessionarioCommittente.Sede.CAP = response[0];
            }
          }, (error) => {
            $rootScope.alert('error', error);
          });
      }
    };
    $scope.getIndirizzoResaCAP = (index) => {
      let state = $scope.FatturaPA.FatturaElettronicaBody[index].DatiGenerali.DatiTrasporto.IndirizzoResa.Provincia;
      let city = $scope.FatturaPA.FatturaElettronicaBody[index].DatiGenerali.DatiTrasporto.IndirizzoResa.Comune;
      ArchiSmallServices.getTypeaheadValues('cap-by-code', 'stateCode=' + state + '&city=' + city)
        .then((response: any) => {
          // alert(response);
          if (response[0] !== '') {
            $scope.FatturaPA.FatturaElettronicaBody[index].DatiGenerali.DatiTrasporto.IndirizzoResa.CAP = response[0];
          }
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.states = [];
    $scope.cities = [];
    if ($stateParams.xmlpath === '') {
      $scope.refreshSedeStates();
      $scope.refreshStabileStateCodes();
      $scope.refreshCessionarioCommittenteStateCodes();
      $scope.refreshStateCodes();
      $scope.refreshCities();
      $scope.refreshStabileCities();
      $scope.refreshCessionarioCommittenteCities();
    }
    // </editor-fold>

    $rootScope.formsubmitted = false;
    $rootScope.loading = false;
    $scope.emptyIfFieldChanged = (dependentModel1, dependentModel2, dependentModel3) => {
      $parse(dependentModel1).assign($scope, '');
      if (dependentModel2) {
        $parse(dependentModel2).assign($scope, '');
      }
      if (dependentModel3) {
        $parse(dependentModel3).assign($scope, '');
      }
    };
    // <editor-fold desc='DatePicker'>
    $scope.dpOpened = {
      CedentePrestatoreDataIscrizioneAlbo: false
    };
    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    $scope.autoOpen = ($event, opened) => {

      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    $scope.calendar = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index) => {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar.opened[which] = [];
        $scope.calendar.opened[which][index] = true;
      }
    };
    $scope.autoOpenCalendar = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index) => {

        if (appContext.userBrowser['isIE']) {
          return;
        }

        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar.opened[which] = [];
        $scope.calendar.opened[which][index] = true;
      }
    };
    $scope.calendar2 = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index1, index2) => {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar2.opened[which] = [];
        $scope.calendar2.opened[which][index1] = [];
        $scope.calendar2.opened[which][index1][index2] = true;
      }
    };
    $scope.autoOpenCalendar2 = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index1, index2) => {

        if (appContext.userBrowser['isIE']) {
          return;
        }

        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar2.opened[which] = [];
        $scope.calendar2.opened[which][index1] = [];
        $scope.calendar2.opened[which][index1][index2] = true;
      }
    };
    $scope.calendar3 = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index1, index2, index3) => {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar3.opened[which] = [];
        $scope.calendar3.opened[which][index1] = [];
        $scope.calendar3.opened[which][index1][index2] = [];
        $scope.calendar3.opened[which][index1][index2][index3] = true;
      }
    };
    $scope.autoOpenCalendar3 = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index1, index2, index3) => {

        if (appContext.userBrowser['isIE']) {
          return;
        }

        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar3.opened[which] = [];
        $scope.calendar3.opened[which][index1] = [];
        $scope.calendar3.opened[which][index1][index2] = [];
        $scope.calendar3.opened[which][index1][index2][index3] = true;
      }
    };
    // </editor-fold>
    $scope.isCedentePrestatoreIdCodiceDisabled = function () {
      const isDisabled = !['TD16', 'TD17', 'TD18', 'TD19', 'TD20', 'TD21', 'TD22'].includes($scope.FatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.TipoDocumento);
      if (isDisabled) {
        // restore dati anagrafici
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice = $scope.backupCedentePrestatoreIdCodice;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese = $scope.backupCedentePrestatoreCodicePaese;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.CodiceFiscale = $scope.backupCedentePrestatoreFiscalCode;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Nome = $scope.backupFirstName;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Cognome = $scope.backupSurname;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione = $scope.backupName;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Titolo = $scope.backupTitolo;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.CodEORI = $scope.backupCodEORI;
        // $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.AlboProfessionale = $scope.backupAlboProfessionale;
        // $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.ProvinciaAlbo = $scope.backupProvinciaAlbo;
        // $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.NumeroIscrizioneAlbo = $scope.backupNumeroIscrizioneAlbo;
        // $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.DataIscrizioneAlbo = $scope.backupDataIscrizioneAlbo;
        // $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.RegimeFiscale = $scope.backupRegimeFiscale;

        // restore sede
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Indirizzo = $scope.backupAddress;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.NumeroCivico = $scope.backupNumeroCivico;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.CAP = $scope.backupCAP;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Comune = $scope.backupCity;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia = $scope.backupProvinceCode;
        $scope.FatturaPA.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione = $scope.backupCodicePaese;
      }
      return isDisabled;
    };
  }

  private getEmptyCessionarioCommittente = () => {
    return {
      DatiAnagrafici: {
        IdFiscaleIVA: {
          IdCodice: '',
          IdPaese: ''
        },
        CodiceFiscale: '',
        Anagrafica: {
          Denominazione: '',
          Titolo: '',
          CodEORI: ''
        }
      },
      Sede: {
        Indirizzo: '',
        NumeroCivico: '',
        CAP: '',
        Comune: '',
        Provincia: '',
        Nazione: ''
      }
    } as ICessionarioCommittente;
  };


  public addEmptyArray(val: any) {
    if (Array.isArray(val)) {
      if (val.length === 0) {
        return [''];
      }
      return val.reduce((res, cur) => {
        if (cur !== '') {
          return [...res, this.addEmptyArray(cur)];
        }
        return res;
      }, []);
    } else if (Object.prototype.toString.call(val) === '[object Object]') {
      return Object.keys(val).reduce((res, key) => {
        if (val[key] !== '') {
          return Object.assign({}, res, {[key]: this.addEmptyArray(val[key])});
        }
        return res;
      }, {});
    }
    return val;
  }

}

export const PrComponiFatturaAvanzataComponent: ng.IComponentOptions = {
  template: require('./pr-componi-fattura-avanzata.html'),
  controller: PrComponiFatturaAvanzataController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/pr-componi-fattura-avanzata/pr-componi-fattura-avanzata.ts